<template>
    <div class="header flex-group flex-between" v-if="pathname!='Activity'" >
      <div class="header-left">
       <img class="back" v-if="pathname!='Ucenter' && pathname!='Login' && pathname!='/'" @click="_goBack" src="~@/assets/back.png" alt="">
      </div>
      <img class="logo" src="~@/assets/logo.png" @click="_goCenter" alt="">
      <div class="header-right"></div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Header',
  props: ['pathname'],
  data(){
    return {

    }
  },
  computed: {
    ...mapState(['lang'])
  },
  methods: {
    _goBack(){
        console.log(this.pathname );
        if(this.pathname == 'Review') {
            this.$router.push('/myqs');
        }else if(this.pathname == 'End' ){
            this.$router.push('/Ucenter');
        } else {
            this.$router.go(-1);
        }
    },
    _goCenter(){
        if (this.pathname!='Login' && this.pathname!='/') {
            this.$router.push('/Ucenter');
        }
    }
  }
}
</script>
    
<style lang="scss" scoped>
    .header{
      padding: rem(40) rem(58);
      .header-left{
        width: rem(99);
        height: rem(99);
        .back{
          width: 100%;
          height: 100%;
        }
      }
      .logo{
        width: rem(363);
        height: rem(222);
      }
      .header-right{
        width: rem(99);
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/Header.vue